import React from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { H1 } from './typography';
import { dark } from '../theme';
import responsive from '../utils/responsive';
import defaultLogo from '../assets/images/logo.png';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  height: 100%;
  margin-top: 12%;
  text-align: center;
  ${responsive.sm.andSmaller`
    margin: 0;
    justify-content: center;
  `}

  ${responsive.md.andSmaller`
    font-size: 0.7rem;
  `};
`;

export const Subtitle = styled(H1)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.6em;

  background: ${props => props.theme.colors.primary.alpha(0.7).toHex()};
  padding: 0.5em 0;
  color: white;
  width: 45%;
  border-radius: 4px;
  
  ${responsive.md.andSmaller`
    font-size: 1.5em;
    width: 100%;
  `};
  
  ${responsive.xs.andSmaller`
    font-size: ${props => props.theme.textSize.l};
  `}

  ${props =>
    props.hideLogo &&
    css`
      padding-bottom: 0.5em;
      border-bottom: 1px solid white;
      width: 30%;
    `}

  ${props =>
    props.invert &&
    css`
      color: black;
      font-weight: 600;
    `}
`;

const Logo = styled.img`
  width: 16em;
  height: 10em;
  object-fit: contain;

  border: 1px solid white;
  border-radius: 50%;
  padding: 1em;

  ${responsive.sm.andSmaller`
    height: 10em;
  `}

  ${props =>
    props.invert &&
    css`
      filter: invert(1);
    `}
`;

const Header = ({
  title,
  subtitle,
  style,
  hideLogo,
  invert,
  LogoComponent,
}) => (
  <ThemeProvider theme={dark}>
    <Container style={style}>
      {!hideLogo &&
        (LogoComponent ? (
          LogoComponent
        ) : (
          <Logo src={defaultLogo} alt={'La villa logo'} invert={invert} />
        ))}
      {subtitle && (
        <Subtitle
          hideLogo={hideLogo}
          style={{ textTransform: 'uppercase' }}
          invert={invert}
        >
          {subtitle}
        </Subtitle>
      )}
    </Container>
  </ThemeProvider>
);

export default Header;